import { Autocomplete, Box, Popper, TextField, Typography } from '@mui/material'

export default function TimeZoneSelect({
  value,
  onChange,
  ...rest
}: {
  value: string
  onChange: (code: string) => void
  disabled: boolean
  sx: any
  label: string
}) {
  const popper = (props: any) => {
    return <Popper {...props} placement="bottom-start" />
  }

  const data = {
    data: { value: [{ aliasOf: 'Europe/London', id: 'Europe/London' }] }, //TODO: Add the API call, when built
  }
  const options = data?.data.value ?? []
  const selectedTimeZone = options.find((tz: any) => tz.id === value) ?? null

  return data ? (
    <Autocomplete
      {...rest}
      id="timeZone"
      sx={{ width: 500 }}
      onChange={(_e, option: any | null) => {
        onChange(option ? option.id : '')
      }}
      PopperComponent={popper}
      onBlur={() => {}}
      value={selectedTimeZone}
      options={options}
      autoHighlight
      getOptionLabel={(option: any) => (option ? `${option.aliasOf}` : '')}
      renderOption={(props, option) => {
        return (
          <Box
            key={option.id}
            component="li"
            sx={{
              display: 'flex',
              alignItems: 'flex-start !important',
              flexDirection: 'column',
            }}
            {...props}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                flexDirection: 'column',
                gap: '4px',
              }}
            >
              <Typography
                fontWeight={700}
                noWrap
              >{`${option.aliasOf}`}</Typography>
            </Box>
          </Box>
        )
      }}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            label={'Select a timezone'}
            inputProps={{
              ...params.inputProps,
              autoComplete: 'off',
            }}
          />
        )
      }}
    />
  ) : (
    <></>
  )
}
